import { __exports as ToIntegerIfIntegral } from "../../../../../_virtual/ToIntegerIfIntegral.mjs";
import require$$0 from "../../../../../_virtual/index2.mjs";
var hasRequiredToIntegerIfIntegral;
function requireToIntegerIfIntegral() {
  if (hasRequiredToIntegerIfIntegral) return ToIntegerIfIntegral;
  hasRequiredToIntegerIfIntegral = 1;
  Object.defineProperty(ToIntegerIfIntegral, "__esModule", { value: true });
  ToIntegerIfIntegral.ToIntegerIfIntegral = void 0;
  var ecma402_abstract_1 = require$$0;
  function ToIntegerIfIntegral$1(arg) {
    var number = (0, ecma402_abstract_1.ToNumber)(arg);
    if (!Number.isInteger(number)) {
      throw new RangeError("".concat(arg, " is not an integer"));
    }
    return number;
  }
  ToIntegerIfIntegral.ToIntegerIfIntegral = ToIntegerIfIntegral$1;
  return ToIntegerIfIntegral;
}
export {
  requireToIntegerIfIntegral as __require
};
